export const pt = {
  pageTitle: "Vales-presente",
  searchPlaceholder: "Pesquisar vales-presente",
  helpShop: "Veja vales-presente e recompensas disponiveis.",
  helpMyCards: "Veja os vales-presente que voce ja comprou.",
  tabShop: "Comprar",
  tabMyCards: "Meus cartoes",
  loading: "Carregando vales-presente...",
  defaultBrand: "Vale-presente",
  noArtwork: "Sem imagem",
  unavailableTitle: "Vales-presente indisponiveis",
  unavailableBody:
    "Nao foi possivel carregar os vales-presente agora. Tente novamente mais tarde.",
  shopErrorTitle: "Nao foi possivel carregar os vales-presente",
  shopErrorBody: "Atualize a pagina ou tente novamente em instantes.",
  catalogEmptyTitle: "Nenhum vale-presente encontrado",
  catalogEmptyBody: "Tente outra pesquisa ou pais.",
  signInTitle: "Entre para ver seus vales-presente",
  signInBody: "Seus vales-presente comprados ficam disponiveis apos o login.",
  signIn: "Log in",
  bagEmptyTitle: "Nenhum vale-presente ainda",
  bagEmptyBody: "Os vales-presente que voce comprar aparecerao aqui.",
  noMatches: "Nenhum vale-presente correspondente",
  earnUpToPercentBack: "Ganhe ate {{value}}% de volta",
  earnUpToCashBack: "Ganhe ate {{amount}} de volta",
  continueToPurchase: "Continuar para a compra",
  selectAmount: "Escolha um valor",
  customAmount: "Valor personalizado",
  customAmountPlaceholder: "Digite um valor",
  amountRangeHint: "Digite um valor entre {{min}} e {{max}}",
  amountMinHint: "Digite pelo menos {{min}}",
  amountMaxHint: "Digite no maximo {{max}}",
  amountInvalid: "Digite um valor valido",
  back: "Voltar",
  youPay: "Voce paga",
  youEarn: "Voce ganha",
  paymentHeadlinePrefix: "Voce esta pagando {{amount}}",
  paymentHeadlineJoiner: "e",
  paymentHeadlineReward: "ganhando {{reward}}",
  paymentHeadlineRewardType: "em dinheiro ({{currency}})",
  paymentMethod: "Forma de pagamento",
  confirmPay: "Confirmar e pagar {{amount}}",
  signInToPurchase: "Entre para comprar",
  processing: "Processando sua compra...",
  addNewCard: "Adicionar um cartao",
  card: "Cartao",
  cardEndingIn: "Terminando em {{last4}}",
  cardExpires: "Val {{month}}/{{year}}",
  cardDetails: "Detalhes do cartao",
  postalCode: "Codigo postal",
  postalCodePlaceholder: "A1A 1A1",
  saveCard: "Salvar cartao",
  savingCard: "Salvando...",
  cancel: "Cancelar",
  stripeUnavailable: "Pagamentos com cartao nao estao disponiveis no momento.",
  cardSetupError: "Nao foi possivel iniciar a configuracao do cartao. Tente novamente.",
  cardError: "Nao foi possivel salvar seu cartao. Verifique os dados e tente novamente.",
  methodsError: "Nao foi possivel carregar seus cartoes salvos.",
  paymentError: "Seu pagamento nao pode ser concluido. Tente novamente.",
  cardDeclined: "Seu cartao foi recusado. Tente outro cartao.",
  insufficientFunds: "Saldo insuficiente no cartao. Tente outro cartao.",
  purchaseComplete: "Compra concluida",
  purchaseCompleteBody: "Seu vale-presente de {{amount}} esta pronto em Meus cartoes.",
  youPaid: "Voce pagou",
  youEarned: "Voce ganhou",
  viewMyWallet: "Ver minha carteira",
  cardNumber: "Numero do cartao",
  pin: "PIN",
  barcodeAlt: "Codigo de barras do vale-presente",
  noImage: "Nenhuma imagem disponivel",
  amount: "Valor",
  purchasedFor: "Comprado por",
  balance: "Saldo",
  description: "Descricao",
  howToUse: "Como usar",
  terms: "Termos e Condicoes",
  emptyDetails: "Nenhum detalhe adicional disponivel.",
  close: "Fechar",
};
